import React from 'react';
import AnnexesInputComponent from './AnnexesInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

const AnnexesInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <AnnexesInputComponent question={question} />;
  }
};

export default AnnexesInputPicker;
